module.exports = __webpack_public_path__ + "img/803e7301b2ceee013b1dea1bdd8ab41d.d5df9a2e.jpg";